import {
    FETCH_PLAN_CONTENT_REQUEST,
    FETCH_PLAN_CONTENT_SUCCESS,
    FETCH_PLAN_CONTENT_FAILURE
} from '../Actions/planContentActions';

const initialState = {
    content: {
        // Default values
        page_title: 'Membership and Prices',
        current_subscription_title: 'Current Subscription',
        active_badge_text: '✓ Active',
        label_plan_name: 'Plan Name',
        label_billing_cycle: 'Billing Cycle',
        label_price: 'Price',
        label_expires_on: 'Expires On',
        table_header_features: 'Features',
        feature_premium_content_title: 'Premium Content',
        feature_premium_content_desc: 'Movies, Web series, TV shows, download',
        feature_music_title: 'Music',
        feature_music_desc: 'Unlimited Playlists',
        feature_live_tv_title: 'Live TV',
        feature_ad_free_title: 'Plan Description',
        feature_ad_free_desc: 'For Premium Content',
        feature_device_title: 'Device',
        feature_screens_title: 'No of screens',
        feature_video_quality_title: 'Max Video Quality',
        feature_audio_quality_title: 'Max Audio Quality',
        feature_audio_quality_desc: 'Dolby 5.1',
        payment_dropdown_label: 'Select Payment Method',
        buy_button_text: 'Buy Plan'
    },
    loading: false,
    error: null
};

const planContentReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_PLAN_CONTENT_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case FETCH_PLAN_CONTENT_SUCCESS:
            return {
                ...state,
                loading: false,
                content: {
                    ...state.content,
                    ...action.payload
                },
                error: null
            };

        case FETCH_PLAN_CONTENT_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        default:
            return state;
    }
};

export default planContentReducer;
